import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import createBookWithID from "../../utils/CreateBookWithID";

const initialState = [];

export const fetchBook = createAsyncThunk("books/fetchBook", async () => {
   const res = await axios.get("http://localhost:4000/random-book");
   return res.data;
});

const booksSlice = createSlice({
   name: "books",
   initialState: initialState,
   reducers: {
      addBook: (state, action) => {
         state.push(action.payload);
      },
      deleteBook: (state, action) => {
         return state.filter((book) => book.id !== action.payload);
      },
      toggleFavorit: (state, action) => {
         state.forEach((book) => {
            if (book.id === action.payload) {
               book.isFavorit = !book.isFavorit;
            }
         });
         // return state.map((book) =>
         //    book.id === action.payload
         //       ? { ...book, isFavorit: !book.isFavorit }
         //       : book
         // );
      },
   },
   extraReducers: (builder) => {
      builder.addCase(fetchBook.fulfilled, (state, action) => {
         if (action.payload.title && action.payload.author)
            state.push(createBookWithID(action.payload, "API"));
      });
   },
});

export const thunkFunction = async (dispatch, getState) => {
   try {
      const res = await axios.get("http://localhost:4000/random-book");
      if (res?.data?.title && res?.data?.author) {
         dispatch(addBook(createBookWithID(res.data, "API")));
      }
   } catch (error) {
      console.log("Error fetching random book", error);
   }
};

export const { addBook, deleteBook, toggleFavorit } = booksSlice.actions;
export const selectBooks = (state) => state.books;

export default booksSlice.reducer;
